var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('b-pagination',{staticClass:"mt-1",attrs:{"per-page":_vm.itemsPerPage,"limit":5,"total-rows":_vm.totalItems,"disabled":_vm.dataLoading,"align":"fill"},on:{"change":_vm.pageChanged},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }